export var getSubEntityObject = function (officeContent) {
    var documentId = officeContent.docId, driveId = officeContent.driveId, fileName = officeContent.fileName, fileType = officeContent.fileType, objectUrl = officeContent.webUrl, url = officeContent.url;
    return {
        documentId: documentId,
        driveId: driveId,
        fileName: fileName,
        fileType: fileType,
        objectUrl: objectUrl,
        url: url,
    };
};
// TypeGuards
export var isAppExecutionInfo = function (executionInfo) {
    return executionInfo.appId !== undefined;
};
export var isExternalAppExecutionInfo = function (executionInfo) {
    return executionInfo.target !== undefined;
};
export var isExternalUrlExecutionInfo = function (executionInfo) {
    return executionInfo.url !== undefined;
};
export var isInContextAppExecutionInfo = function (executionInfo) {
    return executionInfo.appId !== undefined;
};
export var isInContextExternalUrlExecutionInfo = function (executionInfo) {
    return executionInfo.url !== undefined;
};
//# sourceMappingURL=util.js.map